<script>
import deleteTeamModal from "../../components/modals/modal-delete-team.vue";
import createTeamSidebar from "../../components/settings/setting-create-team-sidebar.vue";

export default {
  name: "teams",
  components: {
    deleteTeamModal,
    createTeamSidebar
  },
  methods: {
    loadTeams: async function (preventEvent) {
      this.teams = await this.$A.TeamService.GetAccountTeams() || [];
      this.loaded = true;
      if (!preventEvent) {
        this.$emit("updated", this.teams);
      }
    },
    editTeam: function (team) {
      this.$refs.teamEditor.openForEdit(team);
    },
    deleteTeam: async function (team) {
      this.$refs.deleteTeamModal.open(team, this.teams);
    }
  },
  computed: {
    canCreateTeams: function () {
      const userLimit = _.get(this, '$A.Auth.account.subscriptionState.userLimit', 0);
      return !userLimit || this.users.length < userLimit;
    }
  },
  data() {
    return {
      teams: [],
      users: [],
      loaded: false,
    };
  },
  async mounted() {
    await this.loadTeams(true);
    this.users = await this.$A.AccountService.All() || [];
  },
};
</script>

<template>
  <div class="settings-card">
    <div class="card-head">
      <div class="card-head-title">Teams</div>
      <div class="card-head-subtitle">Create and manage teams in your organization.</div>
    </div>

    <div class="team-rows" v-if="teams.length">
      <div class="team-row" v-for="team in teams" :key="team.id">
        <span class="team-name">{{ team.name }}</span>
        <span class="row-actions">
          <a class="action-link" @click="editTeam(team)">Edit</a>
          <a class="action-link action-danger" @click="deleteTeam(team)">Delete</a>
        </span>
      </div>
    </div>

    <div v-if="loaded && !teams.length" class="list-empty">
      <div class="empty-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      </div>
      <div class="empty-title">No teams yet</div>
      <div class="empty-text">Group your users into teams to control who sees which proofs and keep big accounts organized.</div>
      <a v-if="canCreateTeams" v-b-toggle.create-team-sidebar class="primary-btn empty-cta">Create Team</a>
    </div>

    <delete-team-modal ref="deleteTeamModal" @deleted="loadTeams"/>

    <div class="card-foot">
      <a v-if="canCreateTeams" v-b-toggle.create-team-sidebar class="primary-btn">Create Team</a>
      <button
          v-if="!canCreateTeams"
          class="locked-btn"
          @click="$A.BuyNow()"
          v-b-tooltip.hover="'Upgrade to add additional teams'"
      >
        Feature Locked <img src="/img/feature-lock.svg" class="feature-icon ml-2"/>
      </button>
    </div>
    <create-team-sidebar ref="teamEditor" @saved="loadTeams"/>
  </div>
</template>

<style scoped>
.settings-card {
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.04), 0 8px 24px -16px rgba(8, 11, 13, 0.1);
}
.card-head {
  padding: 14px 20px;
  background: #fbfbfc;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px 12px 0 0;
}
.card-head-title {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}
.card-head-subtitle {
  margin-top: 1px;
  font-size: 12.5px;
  font-weight: 400;
  color: #6b7280;
}
.card-foot {
  display: flex;
  justify-content: flex-end;
  padding: 12px 20px;
  background: #fbfbfc;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 0 0 12px 12px;
}

/* Rows */
.team-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 13px 20px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  transition: background-color 120ms ease;
}
.team-row:hover {
  background: #f9f9fa;
}
.team-row:last-child {
  border-bottom: 0;
}
.team-name {
  font-size: 13.5px;
  font-weight: 500;
  color: #111827;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.row-actions {
  flex-shrink: 0;
  display: flex;
  gap: 14px;
}
.action-link {
  font-size: 12.5px;
  font-weight: 600;
  color: #019256;
  cursor: pointer;
  text-decoration: none;
}
.action-link:hover {
  color: #017a48;
  text-decoration: none;
}
.action-danger {
  color: #b43643;
}
.action-danger:hover {
  color: #8f2a35;
}

/* Empty state */
.list-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 48px 32px;
}
.empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 999px;
  background: rgba(1, 146, 86, 0.1);
  color: #019256;
  margin-bottom: 14px;
}
.empty-title {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
  letter-spacing: -0.01em;
}
.empty-text {
  margin-top: 5px;
  font-size: 12.5px;
  font-weight: 500;
  color: #6b7280;
  line-height: 1.55;
  max-width: 380px;
}
.empty-cta {
  margin-top: 16px;
}

/* Buttons */
.primary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 18px;
  background: #019256;
  color: #fff;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 120ms ease;
}
.primary-btn:hover {
  background: #017a48;
  color: #fff;
  text-decoration: none;
}
.locked-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 16px;
  background: #F44271;
  border: 0;
  color: #fff;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.05);
}
.locked-btn:hover {
  opacity: 0.9;
}
.feature-icon {
  height: 14px;
}

@media (max-width: 575px) {
  .primary-btn,
  .locked-btn {
    flex: 1;
  }
}
</style>
